;(function (site, undefined) {
	"use strict"

	document.addEventListener("DOMContentLoaded", function (e) {
		site.ytPlayer.init()
	})
})(window.site = window.site || {})